import type { CustomerStore } from './interfaces'

export const _setCustomer = (state: CustomerStore, customer: CustomerStore['customer']): void => {
  state.customer = customer
  state.updatedAt = customer ? Date.now() : 0
  state.status = customer ? 'ready' : 'idle'
}
